import { getSalesSummary } from "@/api/report-api";
import { buildCacheKey, useCollectionData } from "@/hooks/use-api";
import { SalesSummaryResponse } from "@/types/report-type";

export function useSalesSummary(fromDate: string, toDate: string) {
    const cacheKey = buildCacheKey("sales-summary", { fromDate, toDate });

    return useCollectionData<SalesSummaryResponse>(
        cacheKey,
        () => getSalesSummary(fromDate, toDate),
        {
            refreshInterval: 0,
            revalidateOnFocus: false,
        }
    );
}
